<template>
  <div class="component-export">
    <el-button size="mini" type="primary" @click="clickExport">导出Excel</el-button>
    <!--<el-button size="mini" type="primary" @click="clickCurrent">导出当前页</el-button>-->
    <!--<el-button size="mini" type="primary" @click="clickAll">导出搜索结果</el-button>-->
  </div>
</template>
<style lang="scss">
  .component-export {
    .el-message-box__message{
      height:30px;
    }
    .el-message-box__status{
      display:none;
    }
    .component-export-cancelButtonClass {
      width:110px;
      background-color: rgba($color-highlight, .8);
      color: #FFF;
      float: none;
      display:block;
      margin:0 auto;
      transform:translateX(-12px);
    }
    .component-export-confirmButtonClass {
      width:110px;
      float: none;
      color: #FFF;
      display:block;
      margin:0 auto!important;
      &:hover {
        color: #FFF;
        background-color: rgba($color-highlight, .6);
      }
    }
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/export/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/export/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/export/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-export')
  export default {
    name: 'base-export', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-export': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>